import $ from 'jquery';

const ReadMore = (el) => {
    const controls = el.getAttribute('aria-controls');

    el.addEventListener('click', (e) => {
        e.preventDefault();
        $(el).siblings().addClass('block-image-text__text--full-text');
        if (controls) {
            const readMoreContainer = document.getElementById(controls);
            readMoreContainer.classList.remove('has-more-text')
        }
        el.remove();
    });
};

export default ReadMore;
